module.exports = __webpack_public_path__ + "assets/0ac56dc0dbaac07a73bd4a176ee6f6d5.png";